module.exports = __webpack_public_path__ + "static/media/success-icon.851c8c1a.svg";